import {
  createRouter,
  createWebHashHistory,
  RouteRecordRaw,
  createWebHistory
} from 'vue-router'
import moment from 'moment'
import environment from '@/configs/environtment'
import Main from '@/views/layouts/Main.vue'
import Login from '@/views/pages/auth/Login.vue'
import LoginHjex from '@/views/pages/auth/LoginHjex.vue'

import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import store from '../store'

const baseRoute = '/hrd'
const checkUserInfo = () => {
  if (localStorage.getItem('userInfo')) {
    // const userInfo = JSON.parse(encryptDecriptMethods.decrypt(localStorage.getItem('userInfo')))
    const userInfo = localStorage.getItem('userInfo')
    console.log('zczxcz', userInfo)
  }
  if (localStorage.getItem('rn') === 'External') {
    console.log('aaa')
    return 'reports-advance'
  }
  if (localStorage.getItem('ut')) {
    return 'dashboard'
  }
  return ''
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    // eslint-disable-next-line consistent-return
    beforeEnter: async () => {
      const ut = localStorage.getItem('ut')
      console.log('utx', ut)
      if (ut) {
        return `${baseRoute}/`
        // eslint-disable-next-line no-else-return
      } else {
        // console.log('environtment', environment.getHydraApi())
        return '/login'
      }
    },
    component: () => import('@/views/pages/Home.vue')
  },
  {
    path: '/portal',
    name: 'Portal',
    component: () => import('@/views/pages/portal/Index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      // this meta property is used to define that the route can acces when user don't have token access
      hideForAuth: true
    }
  },
  {
    path: '/logout-successful',
    name: 'Logout',
    beforeEnter: async () => {
      store.dispatch('logoutAccount')
      return '/login'
    },
    component: Login,
    meta: {
      hideForAuth: true
    }
  },
  {
    path: '/login-hjex',
    name: 'Login-hjex',
    component: LoginHjex,
    meta: {
      hideForAuth: true
    }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/views/pages/auth/ForgotPassword.vue')
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/pages/auth/ChangePassword.vue')
  },
  {
    path: '/callback',
    name: 'callback',
    component: () => import('@/views/pages/auth/Callback.vue'),
    // meta: {
    //   // hideForAuth: true
    //   requiresAuth: true
    // }
  },
  {
    path: `${baseRoute}`,
    // eslint-disable-next-line no-nested-ternary
    // redirect: `${baseRoute}/${localStorage.getItem('ut') === null ? '' : store.state.userProfile?.RolesName === 'External' ? 'reports' : 'dashboard'}`,
    redirect: `${baseRoute}/${checkUserInfo()}`,
    name: 'Main',
    component: Main,
    meta: {
      // this meta property is used to define that the route can acces when user have token access
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/pages/dashboard/index.vue'),
        meta: {
          group: 'DASHBOARD',
          title: 'Dashboard',
        }
      },
      {
        path: 'master-employee',
        name: 'master-employee',
        component: () => import('@/views/pages/employee/Index.vue'),
        meta: {
          group: 'MASTER KARYAWAN',
          title: 'Master Karyawan',
        }
      },
      {
        path: 'master-employee/form/:id?',
        name: 'master-employee-form',
        component: () => import('@/views/pages/employee/Form.vue'),
        meta: {
          group: 'MASTER KARYAWAN',
          title: 'Master Karyawan'
        }
      },
      {
        path: 'master-position',
        name: 'master-position',
        component: () => import('@/views/pages/position/Index.vue'),
        meta: {
          group: 'MASTER DIVISI',
          title: 'Master Divisi',
        }
      },
      {
        path: 'master-position/detail/:id?',
        name: 'master-position-detail',
        component: () => import('@/views/pages/position/Detail.vue'),
        meta: {
          group: 'MASTER DIVISI',
          title: 'Master Divisi'
        }
      },
      {
        path: 'master-position/form/:id?',
        name: 'master-position-form',
        component: () => import('@/views/pages/position/Form.vue'),
        meta: {
          group: 'MASTER DIVISI',
          title: 'Tambah Daftar Divisi'
        }
      },
      {
        path: 'master-document-type',
        name: 'master-document-type',
        component: () => import('@/views/pages/document/Index.vue'),
        meta: {
          group: 'MASTER DOKUMEN',
          title: 'Master Dokumen',
        }
      },
      {
        path: 'master-region',
        name: 'master-region',
        component: () => import('@/views/pages/region/Index.vue'),
        meta: {
          group: 'MASTER WILAYAH',
          title: 'Master wilayah',
        }
      },
      {
        path: 'master-building',
        name: 'master-building',
        component: () => import('@/views/pages/building/Index.vue'),
        meta: {
          group: 'MASTER GEDUNG',
          title: 'Master Gedung',
        }
      },
      {
        path: 'master-penalty-fine-category',
        name: 'master-penalty-fine-category',
        component: () => import('@/views/pages/penalty-fine-category/Index.vue'),
        meta: {
          group: 'MASTER KATEGORI DENDA',
          title: 'Master Kategori Denda',
        }
      },
      {
        path: 'violation-card',
        name: 'violation-card',
        component: () => import('@/views/pages/violation-card/Index.vue'),
        meta: {
          group: 'KARTU KARYAWAN',
          title: 'Kartu Pelanggaran',
        }
      },
      {
        path: 'violation-card/form/:id?',
        name: 'violation-card-form',
        component: () => import('@/views/pages/violation-card/Form.vue'),
        meta: {
          group: 'KARTU KARYAWAN',
          title: 'Kartu Pelanggaran',
        }
      },
      {
        path: 'violation-card/detail/:id?',
        name: 'violation-card-detail',
        component: () => import('@/views/pages/violation-card/Detail.vue'),
        meta: {
          group: 'KARTU KARYAWAN',
          title: 'Kartu Pelanggaran',
        }
      },
    ]
  },
  {
    path: '/xxx',
    name: 'xx',
    component: () => import('@/views/components/camera/takeCamera.vue'),
    meta: {
      group: 'DASHBOARD',
      title: 'Laporan'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

const checkDateExpired = (): boolean => {
  const token = localStorage.getItem('ut')
  // const timeExpired = moment(localStorage.getItem('ei'))
  const timeExpired = Number(localStorage.getItem('ei'))
  if (token && timeExpired) {
    if (timeExpired > 0) {
      return true
    }
    // const now = moment()
    // const checkHours = moment.duration(now.diff(timeExpired)).asHours()
    // if (checkHours <= 48) {
    //   return true
    // }
  }
  store.dispatch('logoutAccount')

  return false
}

router.beforeEach((to, from, next) => {
  store.dispatch('hideLoading')
  const token = localStorage.getItem('ut')
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (checkDateExpired()) {
      if (token) {
        next()
      } else {
        next({ name: 'Home' })
      }
    } else {
      next({ name: 'Home' })
    }
  } else if (to.matched.some((record) => record.meta.hideForAuth)) {
    // if the user have token then he can access
    if (checkDateExpired()) {
      if (token) {
        next({ name: 'dashboard' })
      } else {
        next()
      }
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
